import { montclairConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function MontclairPage() {
  return <CityPageTemplate config={montclairConfig} />;
}